import { IRequester, requester } from "src/libraries/requester";
import { IResponse } from "src/libraries/requester/IRequester/IResponse";
import { ILinks, links } from "src/Links";
import { INltdevskeleton } from "./INltdevskeleton";
import { GetNltdevskeletonsDto } from "./dto/list-categories-dto";

class NltdevskeletonsService {
    constructor(
        private requester: IRequester,
        private links: ILinks,
    ) { }


    create = async (body: FormData): Promise<IResponse<any>> => {
        try {
            const response = await this.requester.postFormData(this.links.nltdevskeletons, body);
            return response;
        } catch (error) {
            console.warn('NltdevskeletonsService -> create: ', this.links.nltdevskeletons, error);
            return { isError: true, data: null, message: '' } as any;
        }
    }

    list = async (body?: GetNltdevskeletonsDto): Promise<IResponse<any>> => {
        try {
            const url = new URL(this.links.nltdevskeletons);
            if (body) {
                Object.keys(body).forEach(key => url.searchParams.append(key, body[key]));
            }
            const response = await this.requester.get(url.href);
            return response;
        } catch (error) {
            console.warn('NltdevskeletonsService -> list: ', this.links.nltdevskeletons, error);
            return { isError: true, data: null, message: '' } as any;
        }
    }

    update = async (id: number, body: FormData) => {
        try {
            const url = this.links.nltdevskeletons + '/' + id;
            const response = await this.requester.patchFormData(url, body);
            return response;
        } catch (error) {
            console.warn('NltdevskeletonsService -> update: ', this.links.nltdevskeletons, error);
            return { isError: true, data: null, message: '' } as any;
        }
    }

    get = async (id: number | string): Promise<IResponse<INltdevskeleton>> => {
        try {
            const response = await this.requester.get(this.links.nltdevskeletons + '/' + id);
            return response;
        } catch (error) {
            console.warn('NltdevskeletonsService -> get: ', this.links.nltdevskeletons, error);
            return { isError: true, data: null, message: '' } as any;
        }
    }

    delete = async (id: number): Promise<IResponse<any>> => {
        try {
            const response = await this.requester.delete(this.links.nltdevskeletons + `/${id}`);
            return response;
        } catch (error) {
            console.warn('NltdevskeletonsService -> delete: ', this.links.nltdevskeletons, error);
            return { isError: true, data: null, message: '' } as any;
        }
    }

}

export const nltdevskeletonsService = new NltdevskeletonsService(requester, links);